(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[641],{

/***/ "87fa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Videos", function() { return Videos; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Videos = function Videos(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 491 491"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M245.5 491C110.1 491 0 380.9 0 245.5S110.1 0 245.5 0 491 110.1 491 245.5 380.9 491 245.5 491zm0-467.1c-122.2 0-221.6 99.4-221.6 221.6 0 122.2 99.4 221.6 221.6 221.6s221.6-99.4 221.6-221.6c0-122.2-99.4-221.6-221.6-221.6z"
  }), __jsx("path", {
    d: "M186.7 370.6c-4.3 0-8.6-1-12.3-3-9.1-5-14.4-15.4-14.4-28.6V152.1c0-13.2 5.4-23.6 14.4-28.6 9.2-5.1 21-3.8 32.3 3.4l142.8 90.7c11.1 7 17.4 17.3 17.4 28s-6.3 20.9-17.3 27.9l-143 90.6c-6.7 4.3-13.5 6.5-19.9 6.5zm.1-231.5c-1.2 0-2.4.2-3.3.7-2.9 1.6-4.6 6.1-4.6 12.2v186.8c0 6.1 1.7 10.7 4.6 12.2 3 1.6 7.8.5 13.1-2.8l143-90.6c5.5-3.5 8.6-7.8 8.6-12.1s-3.2-8.7-8.8-12.3l-142.8-90.7c-3.5-2.2-7-3.4-9.8-3.4z"
  }));
};

/***/ })

}]);